module.exports = __webpack_public_path__ + "img/BOSPictureFive.192c3b15.png";